import { makeObservable, observable, computed, action } from 'mobx';

import * as JSFUNC from '../../Library/JSFUNC.js';
import * as JSPHP from '../../CaptureExecLocalDatabaseMobx/JSPHP.js';

import DatabaseMobx from '../../CaptureExecLocalDatabaseMobx/DatabaseMobx.js';
import UserMobx from '../../CaptureExecLocalDatabaseMobx/UserMobx.js';

import CaptureExecMobx from '../CaptureExec/CaptureExecMobx.js';
import OpenCaptureMobx from '../OpenCapture/OpenCaptureMobx.js';

class AdminIntegrationsMobx {
  o_selectedTabDbName = "setup"; //"setup", "mapping", "specialHandling",  "log"
  o_setupVerifyApiCredentialsSelectedCredentialsRowIDOrM1 = -1;
  o_setupVerifyApiCredentialsFlag = "start"; //"start", "working", "verified", "credentialsFailed", "ceError"
  o_setupViewOauthTokenFlag = "start"; //"start", "working", "clearSuccess", "clearError"
  o_setupViewOauthTokenJsonString = "";
  o_setupViewOauthTokenExpirationDateTimeUtc = "";
  o_mappingExampleFieldsPanelOpenTF = false;
  o_mappingExampleFieldsIntegrationOppIDString = "";
  o_mappingExampleFieldsFlag = "start"; //"start", "working", "verified", "credentialsFailed", "ceError"
  o_mappingExampleFieldsFetchedIntegrationOppsJsonString = "";
  o_mappingCollapsedLinkedFieldIDsArray = [];
  o_integrationsChangelogLoadingDataOrErrorUndefinedTFU = false;

  constructor() {
    makeObservable(this, {
      o_selectedTabDbName: observable,
      o_setupVerifyApiCredentialsSelectedCredentialsRowIDOrM1: observable,
      o_setupVerifyApiCredentialsFlag: observable,
      o_setupViewOauthTokenFlag: observable,
      o_setupViewOauthTokenJsonString: observable,
      o_setupViewOauthTokenExpirationDateTimeUtc: observable,
      o_mappingExampleFieldsPanelOpenTF: observable,
      o_mappingExampleFieldsIntegrationOppIDString: observable,
      o_mappingExampleFieldsFlag: observable,
      o_mappingExampleFieldsFetchedIntegrationOppsJsonString: observable,
      o_mappingCollapsedLinkedFieldIDsArray: observable,
      o_integrationsChangelogLoadingDataOrErrorUndefinedTFU: observable,

      c_integrationSystemDisplayName: computed,
      c_setupAllIntegrationApiConnectionFieldsArrayOfObjs: computed,
      c_setupSelectedIntegrationUniqueIDCEExpandedCaptureFieldMapOrUndefined: computed,
      c_setupExpandedIntegrationsCredentialsArrayOfObjs: computed,
      c_setupAllIntegrationsCredentialsIDsArray: computed,
      c_selectIntegrationCredentialsFieldTypeObj: computed,
      c_mappingExampleFieldsFetchedIntegrationSingleOppFieldsArrayOfObjsOrUndefined: computed,
      c_linkedFieldsWithValuesArrayOfObjs: computed,
      c_expandedIntegrationsChangelogArrayOfObjs: computed,
      c_selectIntegrationsLogActionsFieldTypeObj: computed,
      c_selectIntegrationFieldDbNameFieldTypeObj: computed,

      a_set_selected_tab_db_name: action,
      a_set_setup_verify_api_credentials_selected_credentials_row_id_or_m1: action,
      a_set_setup_verify_api_credentials_flag: action,
      a_setup_verify_api_credentials: action,
      a_set_setup_view_oauth_token_flag: action,
      a_set_setup_view_oauth_token_json_string: action,
      a_set_setup_view_oauth_token_expiration_datetime_utc: action,
      a_setup_clear_oauth_token: action,
      a_set_mapping_example_fields_panel_open_tf: action,
      a_set_mapping_example_fields_integration_opp_id_string: action,
      a_set_mapping_example_fields_flag: action,
      a_set_mapping_example_fields_fetched_integration_opps_json_string: action,
      a_mapping_example_fields_search_for_integration_opp_by_id_string: action,
      a_create_new_integration_linked_fields_pairing_from_integration_field_db_name: action,
      a_update_linked_fields_field: action,
      a_delete_linked_fields_and_all_mapped_values: action,
      a_create_new_value_pair_under_field_pairing: action,
      a_update_linked_field_values_field: action,
      a_delete_mapped_values_pair: action,
      a_set_mapping_collapsed_linked_field_ids_array: action,
      a_mapping_expand_all_linked_fields: action,
      a_mapping_collapse_all_linked_fields: action,
      a_integrations_changelog_set_loading_data_or_error_undefined_tfu: action,
      a_load_integrations_changelog_data: action
    });
  }


  get c_integrationSystemDisplayName() {
    const c_bitIntegrationSystemVantagePointTF = DatabaseMobx.c_bitIntegrationSystemVantagePointTF;
    if(c_bitIntegrationSystemVantagePointTF) {
      return("VantagePoint");
    }
    return("--Unknown Integration System '" + DatabaseMobx.o_bitcompaniesTblRowMap.get("integration_system") + "'--");
  }


  get c_setupAllIntegrationApiConnectionFieldsArrayOfObjs() {
    const c_companyIntegrationOauthWebAddress = DatabaseMobx.c_companyIntegrationOauthWebAddress;
    const c_companyIntegrationApiWebAddress = DatabaseMobx.c_companyIntegrationApiWebAddress;
    const c_companyIntegrationDatabaseName = DatabaseMobx.c_companyIntegrationDatabaseName;
    const c_companyIntegrationClientIDScramble = DatabaseMobx.c_companyIntegrationClientIDScramble;
    const c_companyIntegrationClientSecretScramble = DatabaseMobx.c_companyIntegrationClientSecretScramble;

    var allIntegrationApiConnectionFieldsArrayOfObjs = [
      {valueRaw:c_companyIntegrationOauthWebAddress, fieldDbName:"integration_oauth_web_address", fieldDisplayName:"OAuth Web Address", inputType:"text", scrambleTF:false},
      {valueRaw:c_companyIntegrationApiWebAddress, fieldDbName:"integration_api_web_address", fieldDisplayName:"API Web Address", inputType:"text", scrambleTF:false},
      {valueRaw:c_companyIntegrationDatabaseName, fieldDbName:"integration_database_name", fieldDisplayName:"Database Name", inputType:"text", scrambleTF:false},
      {valueRaw:c_companyIntegrationClientIDScramble, fieldDbName:"integration_client_id_scramble", fieldDisplayName:"Client ID", inputType:"text", scrambleTF:true},
      {valueRaw:c_companyIntegrationClientSecretScramble, fieldDbName:"integration_client_secret_scramble", fieldDisplayName:"Client Secret", inputType:"text", scrambleTF:true},
    ];

    for(let integrationApiConnectionFieldObj of allIntegrationApiConnectionFieldsArrayOfObjs) {
      integrationApiConnectionFieldObj.isFilledOutTF = JSFUNC.text_or_number_is_filled_out_tf(integrationApiConnectionFieldObj.valueRaw);
    }

    return(allIntegrationApiConnectionFieldsArrayOfObjs);
  }


  get c_setupSelectedIntegrationUniqueIDCEExpandedCaptureFieldMapOrUndefined() {
    const c_tbl_captures_fields = DatabaseMobx.c_tbl_captures_fields;
    const c_companyIntegrationIntegrationUniqueIDCEFieldID = DatabaseMobx.c_companyIntegrationIntegrationUniqueIDCEFieldID;

    if(JSFUNC.select_int_is_filled_out_tf(c_companyIntegrationIntegrationUniqueIDCEFieldID)) {
      return(c_tbl_captures_fields.get(c_companyIntegrationIntegrationUniqueIDCEFieldID)); //either the correct expanded capture field map or undefined
    }
    return(undefined);
  }


  get c_setupExpandedIntegrationsCredentialsArrayOfObjs() {
    const o_tbl_a_integrations_credentials = DatabaseMobx.o_tbl_a_integrations_credentials;
    
    var expandedIntegrationsCredentialsArrayOfObjs = [];
    for(let integrationsCredentialsMap of o_tbl_a_integrations_credentials.values()) {
      var expandedIntegrationsCredentialsObj = JSFUNC.obj_from_map(integrationsCredentialsMap);

      expandedIntegrationsCredentialsArrayOfObjs.push(expandedIntegrationsCredentialsObj);
    }
    return(expandedIntegrationsCredentialsArrayOfObjs);
  }

  get c_setupAllIntegrationsCredentialsIDsArray() {
    const c_setupExpandedIntegrationsCredentialsArrayOfObjs = this.c_setupExpandedIntegrationsCredentialsArrayOfObjs;
    return(JSFUNC.get_column_vector_from_arrayOfObjs(c_setupExpandedIntegrationsCredentialsArrayOfObjs, "id"));
  }

  get c_selectIntegrationCredentialsFieldTypeObj() {
    const c_setupExpandedIntegrationsCredentialsArrayOfObjs = this.c_setupExpandedIntegrationsCredentialsArrayOfObjs;

    const valueDisplayArraysObjAdminChangelogCategories = DatabaseMobx.create_value_display_arrays_obj_from_arrayOfObjs_and_vd_column_names("Integration Credential", c_setupExpandedIntegrationsCredentialsArrayOfObjs, "id", false, "username");
    const swsOptionsObj = {isMultiSelectTF:false, hasSearchTF:false, hasClearSelectionTF:true};
    const selectWithSearchDataObj = DatabaseMobx.create_sws_data_obj_from_value_display_arrays_obj(valueDisplayArraysObjAdminChangelogCategories, swsOptionsObj);
    return(DatabaseMobx.create_field_type_obj("select", selectWithSearchDataObj));
  }


  get c_mappingExampleFieldsFetchedIntegrationSingleOppFieldsArrayOfObjsOrUndefined() {
    const o_mappingExampleFieldsFetchedIntegrationOppsJsonString = this.o_mappingExampleFieldsFetchedIntegrationOppsJsonString;

    const fetchedOppsArrayOfObjsOrUndefined = JSFUNC.parse_json_arrayOfObjs_string_into_arrayOfObjs_or_undefined(o_mappingExampleFieldsFetchedIntegrationOppsJsonString);
    
    if(!JSFUNC.is_array(fetchedOppsArrayOfObjsOrUndefined)) {
      return(undefined);
    }

    var oppFieldsArrayOfObjsOrUndefined = [];
    if(fetchedOppsArrayOfObjsOrUndefined.length >= 1) { //empty array means that 0 results were returned from the fetch
      const fetchedOppObj = fetchedOppsArrayOfObjsOrUndefined[0]; //if multiple opps were fetched from the integration, use the first one as the example
      for(var key in fetchedOppObj) {
        if(fetchedOppObj.hasOwnProperty(key)) {
          oppFieldsArrayOfObjsOrUndefined.push({
            integrationFieldDbName: key,
            integrationValueString: fetchedOppObj[key]
          });
        }
      }
    }
    return(oppFieldsArrayOfObjsOrUndefined);
  }


  get c_linkedFieldsWithValuesArrayOfObjs() {
    const o_tbl_a_integrations_linked_fields = DatabaseMobx.o_tbl_a_integrations_linked_fields;
    const o_tbl_a_integrations_linked_field_values = DatabaseMobx.o_tbl_a_integrations_linked_field_values;

    var linkedFieldsWithValuesArrayOfObjs = [];
    for(let linkedFieldMap of o_tbl_a_integrations_linked_fields.values()) {
      var linkedFieldObj = JSFUNC.obj_from_map(linkedFieldMap);

      //get the selected linked CE field info and fieldTypeObj if it is a select type
      var ceFieldIsValidTF = false;
      var canMapValuesTF = false;
      var ceFieldFieldTypeObjOrUndefined = undefined;
      if(JSFUNC.select_int_is_filled_out_tf(linkedFieldObj.capture_field_id)) {
        var captureFieldMapOrUndefined = DatabaseMobx.c_tbl_captures_fields.get(linkedFieldObj.capture_field_id);
        if(captureFieldMapOrUndefined !== undefined) {
          ceFieldFieldTypeObjOrUndefined = captureFieldMapOrUndefined.get("fieldTypeObj");
          if(ceFieldFieldTypeObjOrUndefined !== undefined) {
            ceFieldIsValidTF = true;
            if(ceFieldFieldTypeObjOrUndefined.requiresSelectWithSearchDataObjTF) {
              canMapValuesTF = true;
            }
          }
        }
      }

      //determine if the integration field dbName has any spaces in it, which displays a red warning
      var integrationFieldDbNameContainsAnySpacesTF = JSFUNC.input_lowercase_string_contains_lowercase_search_term_string_tf(linkedFieldObj.integration_field_db_name, " ");

      //compute fields related to the integration field new capture default value
      var integrationFieldUsingDefaultValueTF = (linkedFieldObj.integration_field_using_default_value_01 === 1);

      //fetch all mapped values for this linked pair
      var mappedValuesArrayOfObjs = []; //no mapped values loaded/shown if the selected CE field is not valid
      if(ceFieldIsValidTF) {
        mappedValuesArrayOfObjs = JSFUNC.filtered_sorted_arrayOfObjs_from_mapOfMaps_matching_field_value(o_tbl_a_integrations_linked_field_values, "linked_field_id", linkedFieldObj.id, "sort", true);
        
        //loop through mapped values and compute the valueMaskSortIfoObj from the CE raw value
        for(let mappedValueObj of mappedValuesArrayOfObjs) {
          //convert CE raw value string from the database to the raw value (int or string) based on the fieldTypeObj
          var captureFieldValueRaw = DatabaseMobx.int_decimal_or_string_value_raw_from_string_value_raw_and_field_type_obj(mappedValueObj.capture_field_value_string, ceFieldFieldTypeObjOrUndefined);
          var captureFieldValueMaskSortIfoObj = DatabaseMobx.value_mask_sort_ifo_obj_from_value_raw_and_field_type_obj(captureFieldValueRaw, ceFieldFieldTypeObjOrUndefined);
          mappedValueObj.captureFieldValueRaw = captureFieldValueRaw;
          mappedValueObj.captureFieldValueMaskSortIfoObj = captureFieldValueMaskSortIfoObj;
        }
      }

      //used when converting a new CE raw value into the integration new value
      var hasAtLeast1MappedValueTF = (mappedValuesArrayOfObjs.length > 0);

      linkedFieldObj.ceFieldIsValidTF = ceFieldIsValidTF;
      linkedFieldObj.canMapValuesTF = canMapValuesTF;
      linkedFieldObj.ceFieldFieldTypeObjOrUndefined = ceFieldFieldTypeObjOrUndefined;
      linkedFieldObj.integrationFieldDbNameContainsAnySpacesTF = integrationFieldDbNameContainsAnySpacesTF;
      linkedFieldObj.integrationFieldUsingDefaultValueTF = integrationFieldUsingDefaultValueTF;
      linkedFieldObj.mappedValuesArrayOfObjs = mappedValuesArrayOfObjs;
      linkedFieldObj.hasAtLeast1MappedValueTF = hasAtLeast1MappedValueTF;

      linkedFieldsWithValuesArrayOfObjs.push(linkedFieldObj);
    }

    JSFUNC.sort_arrayOfObjs(linkedFieldsWithValuesArrayOfObjs, "sort", true);
    
    return(linkedFieldsWithValuesArrayOfObjs);
  }




  get c_expandedIntegrationsChangelogArrayOfObjs() {
    const o_tbl_a_integrations_log = DatabaseMobx.o_tbl_a_integrations_log;

    var expandedIntegrationsChangelogArrayOfObjs = [];
    for(let integrationChangelogMap of o_tbl_a_integrations_log.values()) {
      var expandedIntegrationsChangelogObj = JSFUNC.obj_from_map(integrationChangelogMap);
      
      //compute the html success/failure message blocks displayed in the integration changelog table
      var successErrorBgClass = "";
      var successErrorFontClass = "";
      var successErrorMessage = "";
      if(JSFUNC.string_is_filled_out_tf(expandedIntegrationsChangelogObj.error_message)) {
        if(expandedIntegrationsChangelogObj.error_message.substring(0, 9) === "[skipped]") {
          successErrorBgClass = "bgLightOrange";
          successErrorFontClass = "fontItalic fontTextLight";
        }
        else {
          successErrorBgClass = "bgLightRed";
          successErrorFontClass = "fontDarkRed";
        }
        successErrorMessage = expandedIntegrationsChangelogObj.error_message;
      }
      else {
        successErrorBgClass = "bgLightGreen";
        successErrorFontClass = "fontItalic fontDarkGreen";
        successErrorMessage = "Success";
      }
      var successErrorMask = (
        <div className={"flex11a displayFlexColumnHcVc " + successErrorBgClass + " tbMicroPad lrPad textCenter"}>
          <font className={successErrorFontClass}>
            {successErrorMessage}
          </font>
        </div>
      );
      expandedIntegrationsChangelogObj.successErrorMask = successErrorMask;

      expandedIntegrationsChangelogArrayOfObjs.push(expandedIntegrationsChangelogObj);
    }

    return(expandedIntegrationsChangelogArrayOfObjs);
  }

  get c_selectIntegrationsLogActionsFieldTypeObj() {
    const integrationsLogActionsArrayOfObjs = [
      {dbName:"iCEiIN", displayName:"Insert CE"},
      {dbName:"uCEuIN", displayName:"Update CE"},
      {dbName:"dCEdIN", displayName:"Delete CE"}
    ];
    const swsOptionsObj = {isMultiSelectTF:true, hasSearchTF:false, hasClearSelectionTF:true};
    const selectWithSearchDataObj = DatabaseMobx.create_sws_data_obj_from_arrayOfObjs_and_vd_column_names("Action", integrationsLogActionsArrayOfObjs, "dbName", true, "displayName", swsOptionsObj);
    return(DatabaseMobx.create_field_type_obj("select", selectWithSearchDataObj));
  }

  get c_selectIntegrationFieldDbNameFieldTypeObj() {
    const c_linkedFieldsWithValuesArrayOfObjs = this.c_linkedFieldsWithValuesArrayOfObjs;

    const allIntegrationFieldDbNamesArray = JSFUNC.get_column_vector_from_arrayOfObjs(c_linkedFieldsWithValuesArrayOfObjs, "integration_field_db_name");
    const uniqueIntegrationFieldDbNamesArray = JSFUNC.unique(allIntegrationFieldDbNamesArray);
    JSFUNC.sort_array(uniqueIntegrationFieldDbNamesArray, true, true); //sort fieldDbNames alphabetic case insensitive
    const valueDisplayArraysObjIntegrationsChangelogCategories = DatabaseMobx.create_value_display_arrays_obj_from_value_array_and_display_array("Integration Field Name", uniqueIntegrationFieldDbNamesArray, true, uniqueIntegrationFieldDbNamesArray);
    const swsOptionsObj = {hasSearchTF:true, hasClearSelectionTF:true};
    const selectWithSearchDataObj = DatabaseMobx.create_sws_data_obj_from_value_display_arrays_obj(valueDisplayArraysObjIntegrationsChangelogCategories, swsOptionsObj);
    return(DatabaseMobx.create_field_type_obj("select", selectWithSearchDataObj));
  }





  a_set_selected_tab_db_name(i_tabDbName) {
    this.o_selectedTabDbName = i_tabDbName;
  }

  a_set_setup_verify_api_credentials_selected_credentials_row_id_or_m1(i_newValueInt) {
    this.o_setupVerifyApiCredentialsSelectedCredentialsRowIDOrM1 = i_newValueInt;
  }

  a_set_setup_verify_api_credentials_flag(i_newValueString) {
    this.o_setupVerifyApiCredentialsFlag = i_newValueString;
  }

  a_set_setup_view_oauth_token_flag(i_newValueString) {
    this.o_setupViewOauthTokenFlag = i_newValueString;
  }

  a_set_setup_view_oauth_token_json_string(i_newValueString) {
    this.o_setupViewOauthTokenJsonString = i_newValueString;
  }

  a_set_setup_view_oauth_token_expiration_datetime_utc(i_newValueString) {
    this.o_setupViewOauthTokenExpirationDateTimeUtc = i_newValueString;
  }

  a_setup_verify_api_credentials() {
    const o_setupVerifyApiCredentialsSelectedCredentialsRowIDOrM1 = this.o_setupVerifyApiCredentialsSelectedCredentialsRowIDOrM1;

    this.a_set_setup_verify_api_credentials_flag("working");

    const jsDescription = JSFUNC.js_description_from_action("AdminIntegrationsMobx", "a_setup_verify_api_credentials", [], []);
    const C_CallPhpScript = new JSPHP.ClassCallPhpScript("integrationsFetchSingleOppByIDString", jsDescription);
    C_CallPhpScript.add_post_var("i_integrationsCredentialsTblRowID", o_setupVerifyApiCredentialsSelectedCredentialsRowIDOrM1);
    C_CallPhpScript.add_post_var("i_integrationOppIDString", "");
    C_CallPhpScript.add_return_vars(["integrationOppsJsonString", "integrationErrorMessage"]);

    const functionOnSuccess = (i_parseResponse) => {
      if(i_parseResponse.integrationErrorMessage === "") { //no error from test API fetch
        this.a_set_setup_verify_api_credentials_flag("verified");
      }
      else {
        this.a_set_setup_verify_api_credentials_flag(i_parseResponse.integrationErrorMessage);
      }
      
    }
    C_CallPhpScript.add_function("onSuccess", functionOnSuccess);

    const functionOnError = () => {
      this.a_set_setup_verify_api_credentials_flag("ceError");
    }
    C_CallPhpScript.add_function("onError", functionOnError);

    C_CallPhpScript.execute();
  }

  a_setup_clear_oauth_token() {
    const o_setupVerifyApiCredentialsSelectedCredentialsRowIDOrM1 = this.o_setupVerifyApiCredentialsSelectedCredentialsRowIDOrM1;

    this.a_set_setup_view_oauth_token_flag("working");

    const jsDescription = JSFUNC.js_description_from_action("AdminIntegrationsMobx", "a_setup_clear_oauth_token", [], []);
    const C_CallPhpScript = new JSPHP.ClassCallPhpScript("integrationClearOauthToken", jsDescription);
    C_CallPhpScript.add_post_var("i_integrationsCredentialsTblRowID", o_setupVerifyApiCredentialsSelectedCredentialsRowIDOrM1);
    C_CallPhpScript.add_return_vars(["success01String"]);

    const functionOnSuccess = (i_parseResponse) => {
      if(i_parseResponse.success01String === "1") {
        this.a_set_setup_view_oauth_token_json_string("");
        this.a_set_setup_view_oauth_token_expiration_datetime_utc("");
        this.a_set_setup_view_oauth_token_flag("clearSuccess");
      }
      else {
        this.a_set_setup_view_oauth_token_flag("clearError");
      }
    }
    C_CallPhpScript.add_function("onSuccess", functionOnSuccess);

    const functionOnError = () => {
      this.a_set_setup_view_oauth_token_flag("clearError");
    }
    C_CallPhpScript.add_function("onError", functionOnError);

    C_CallPhpScript.execute();
  }

  a_set_mapping_example_fields_panel_open_tf(i_newValueTF) {
    this.o_mappingExampleFieldsPanelOpenTF = i_newValueTF;
  }

  a_set_mapping_example_fields_integration_opp_id_string(i_newValueString) {
    this.o_mappingExampleFieldsIntegrationOppIDString = i_newValueString;
  }

  a_set_mapping_example_fields_flag(i_newValueString) {
    this.o_mappingExampleFieldsFlag = i_newValueString;
  }

  a_set_mapping_example_fields_fetched_integration_opps_json_string(i_newValueString) {
    this.o_mappingExampleFieldsFetchedIntegrationOppsJsonString = i_newValueString;
  }

  a_mapping_example_fields_search_for_integration_opp_by_id_string(i_integrationOppIDString) {
    const o_setupVerifyApiCredentialsSelectedCredentialsRowIDOrM1 = this.o_setupVerifyApiCredentialsSelectedCredentialsRowIDOrM1;

    this.a_set_mapping_example_fields_flag("working");

    const jsDescription = JSFUNC.js_description_from_action("AdminIntegrationsMobx", "a_mapping_example_fields_search_for_integration_opp_by_id_string", ["i_integrationOppIDString"], [i_integrationOppIDString]);
    const C_CallPhpScript = new JSPHP.ClassCallPhpScript("integrationsFetchSingleOppByIDString", jsDescription);
    C_CallPhpScript.add_post_var("i_integrationsCredentialsTblRowID", o_setupVerifyApiCredentialsSelectedCredentialsRowIDOrM1);
    C_CallPhpScript.add_post_var("i_integrationOppIDString", i_integrationOppIDString);
    C_CallPhpScript.add_return_vars(["integrationOppsJsonString", "integrationErrorMessage"]);

    const functionOnSuccess = (i_parseResponse) => {
      if(i_parseResponse.integrationErrorMessage === "") {
        this.a_set_mapping_example_fields_fetched_integration_opps_json_string(i_parseResponse.integrationOppsJsonString);
        this.a_set_mapping_example_fields_flag("verified");
      }
      else {
        this.a_set_mapping_example_fields_flag(i_parseResponse.integrationErrorMessage);
      }
    }
    C_CallPhpScript.add_function("onSuccess", functionOnSuccess);

    const functionOnError = () => {
      this.a_set_mapping_example_fields_flag("ceError");
    }
    C_CallPhpScript.add_function("onError", functionOnError);

    C_CallPhpScript.execute();
  }


  a_create_new_integration_linked_fields_pairing_from_integration_field_db_name(i_integrationFieldDbName) {
    const jsDescription = JSFUNC.js_description_from_action("AdminIntegrationsMobx", "a_create_new_integration_linked_fields_pairing_from_integration_field_db_name", ["i_integrationFieldDbName"], [i_integrationFieldDbName]);
    const C_CallPhpTblUID = new JSPHP.ClassCallPhpTblUID(jsDescription);

    const fieldNamesArray = ["sort", "integration_field_db_name", "capture_field_id"];
    const valuesArray = [JSFUNC.sort_max_mysqli_int(), i_integrationFieldDbName, -1];
    const idsbArray = ["i", "s", "i"];
    const resortSortColumnName = "sort";
    const resortFilterFieldNamesArray = [];
    const resortFilterValuesArray = [];
    C_CallPhpTblUID.add_insert("tbl_a_integrations_linked_fields", fieldNamesArray, valuesArray, idsbArray, resortSortColumnName, resortFilterFieldNamesArray, resortFilterValuesArray);

    C_CallPhpTblUID.execute();
  }


  a_update_linked_fields_field(i_linkedFieldWithValuesObj, i_fieldDbName, i_newValue, i_idsb) {
    const jsDescription = JSFUNC.js_description_from_action("AdminIntegrationsMobx", "a_update_linked_fields_field", ["i_linkedFieldWithValuesObj", "i_fieldDbName", "i_newValue", "i_idsb"], [i_linkedFieldWithValuesObj, i_fieldDbName, i_newValue, i_idsb]);
    const C_CallPhpTblUID = new JSPHP.ClassCallPhpTblUID(jsDescription);
    C_CallPhpTblUID.add_update("tbl_a_integrations_linked_fields", i_linkedFieldWithValuesObj.id, i_fieldDbName, i_newValue, i_idsb);
    C_CallPhpTblUID.execute();
  }


  a_delete_linked_fields_and_all_mapped_values(i_linkedFieldWithValuesObj) {
    var mappedValuesIDsToDeleteArray = [];
    if(JSFUNC.is_array(i_linkedFieldWithValuesObj.mappedValuesArrayOfObjs)) {
      mappedValuesIDsToDeleteArray = JSFUNC.get_column_vector_from_arrayOfObjs(i_linkedFieldWithValuesObj.mappedValuesArrayOfObjs, "id");
    }

    const jsDescription = JSFUNC.js_description_from_action("AdminIntegrationsMobx", "a_delete_linked_fields_and_all_mapped_values", ["i_linkedFieldWithValuesObj"], [i_linkedFieldWithValuesObj]);
    const C_CallPhpTblUID = new JSPHP.ClassCallPhpTblUID(jsDescription);

    if(mappedValuesIDsToDeleteArray.length > 0) {
      C_CallPhpTblUID.add_delete("tbl_a_integrations_linked_field_values", mappedValuesIDsToDeleteArray);
    }

    C_CallPhpTblUID.add_delete("tbl_a_integrations_linked_fields", i_linkedFieldWithValuesObj.id, "sort", [], []);

    C_CallPhpTblUID.execute();
  }


  a_create_new_value_pair_under_field_pairing(p_linkedFieldWithValuesObj, i_newIntegrationValueString) {
    const jsDescription = JSFUNC.js_description_from_action("AdminIntegrationsMobx", "a_create_new_value_pair_under_field_pairing", ["p_linkedFieldWithValuesObj", "i_newIntegrationValueString"], [p_linkedFieldWithValuesObj, i_newIntegrationValueString]);
    const C_CallPhpTblUID = new JSPHP.ClassCallPhpTblUID(jsDescription);

    const fieldNamesArray = ["sort", "linked_field_id", "integration_value_string", "capture_field_value_string", "extra_capture_field_value_strings_comma"];
    const valuesArray = [JSFUNC.sort_max_mysqli_int(), p_linkedFieldWithValuesObj.id, i_newIntegrationValueString, "", ""];
    const idsbArray = ["i", "i", "s", "s", "s"];
    const resortSortColumnName = "sort";
    const resortFilterFieldNamesArray = ["linked_field_id"];
    const resortFilterValuesArray = [p_linkedFieldWithValuesObj.id];
    C_CallPhpTblUID.add_insert("tbl_a_integrations_linked_field_values", fieldNamesArray, valuesArray, idsbArray, resortSortColumnName, resortFilterFieldNamesArray, resortFilterValuesArray);

    C_CallPhpTblUID.execute();
  }


  a_update_linked_field_values_field(i_mappedValueObj, i_fieldDbName, i_newValue, i_idsb) {
    const jsDescription = JSFUNC.js_description_from_action("AdminIntegrationsMobx", "a_update_linked_fields_field", ["i_mappedValueObj", "i_fieldDbName", "i_newValue", "i_idsb"], [i_mappedValueObj, i_fieldDbName, i_newValue, i_idsb]);
    const C_CallPhpTblUID = new JSPHP.ClassCallPhpTblUID(jsDescription);
    C_CallPhpTblUID.add_update("tbl_a_integrations_linked_field_values", i_mappedValueObj.id, i_fieldDbName, i_newValue, i_idsb);
    C_CallPhpTblUID.execute();
  }


  a_delete_mapped_values_pair(i_mappedValueObj) {
    const jsDescription = JSFUNC.js_description_from_action("AdminIntegrationsMobx", "a_delete_mapped_values_pair", ["i_mappedValueObj"], [i_mappedValueObj]);
    const C_CallPhpTblUID = new JSPHP.ClassCallPhpTblUID(jsDescription);
    C_CallPhpTblUID.add_delete("tbl_a_integrations_linked_field_values", i_mappedValueObj.id, "sort", ["linked_field_id"], [i_mappedValueObj.linked_field_id]);
    C_CallPhpTblUID.execute();
  }


  a_set_mapping_collapsed_linked_field_ids_array(i_newValueArray) {
    this.o_mappingCollapsedLinkedFieldIDsArray = i_newValueArray;
  }
  a_mapping_expand_all_linked_fields() {
    this.o_mappingCollapsedLinkedFieldIDsArray = [];
  }
  a_mapping_collapse_all_linked_fields() {
    const c_linkedFieldsWithValuesArrayOfObjs = this.c_linkedFieldsWithValuesArrayOfObjs;
    this.o_mappingCollapsedLinkedFieldIDsArray = JSFUNC.get_column_vector_from_arrayOfObjs(c_linkedFieldsWithValuesArrayOfObjs, "id");
  }





  a_integrations_changelog_set_loading_data_or_error_undefined_tfu(i_newValueTFU) {
    this.o_integrationsChangelogLoadingDataOrErrorUndefinedTFU = i_newValueTFU;
  }


  a_load_integrations_changelog_data() {
    const c_computedUrlAndProductObj = CaptureExecMobx.c_computedUrlAndProductObj;
    const c_adminIntegrationsChangelogTblNamesToLoadArray = DatabaseMobx.c_adminIntegrationsChangelogTblNamesToLoadArray;

    if(!c_computedUrlAndProductObj.isLocalhost3000SystemTF) {
      this.a_integrations_changelog_set_loading_data_or_error_undefined_tfu(true);

      const functionOnFinish = (i_successTrueErrorFalse) => {
        const updatedLoadingDataOrErrorUndefinedTFU = ((i_successTrueErrorFalse) ? (false) : (undefined));
        this.a_integrations_changelog_set_loading_data_or_error_undefined_tfu(updatedLoadingDataOrErrorUndefinedTFU);
      }
      JSPHP.php_db_api_load_multiple_full_database_tbls_from_tbl_names_array_and_uncompress_and_update_local_memory_maps(c_adminIntegrationsChangelogTblNamesToLoadArray, functionOnFinish);
    }
  }









  
  
  
  //----------------------------------------------------------------------------------------------------------------------------------------------------------
  //3rd Party Integration system Capture insert/update/delete functions (js-php calls to integration system API, followed by CE integration changelog entry inserts)
  //----------------------------------------------------------------------------------------------------------------------------------------------------------
  //---------------------------------------------------------
  //--------- [Insert] 3rd Party Integration system ---------
  //---------------------------------------------------------
  integration_insert_integration_new_opp_with_newly_created_unique_id_string_from_new_ce_capture_id(i_newCECaptureID, i_newCaptureAllCECaptureFieldIDsArray, i_newCaptureAllCERawValuesArray) {
    //alert("integration insert [" + i_newCECaptureID + "]:\nfieldIDs: " + JSFUNC.print_array(i_newCaptureAllCECaptureFieldIDsArray) + "\nvalues: " + JSFUNC.print_array(i_newCaptureAllCERawValuesArray));

    //called for all 3 new capture creation sources: 1) CE Create New Capture, 2) CE GCSS Import, 3) CE Admin Import from .csv
    //  i_newCECaptureID - new capture id autoincrement from insert into tbl_captures
    //  i_newCaptureAllCECaptureFieldIDsArray - every capture fieldID from newly inserted capture (filled out or blank) except `id` [copmuted in DatabaseMobx.create_new_capture_field_names_values_idsb_and_log_arrays_obj_from_new_capture_obj()]
    //  i_newCaptureAllCERawValuesArray - every raw value for each fieldID

    const c_setupSelectedIntegrationUniqueIDCEExpandedCaptureFieldMapOrUndefined = this.c_setupSelectedIntegrationUniqueIDCEExpandedCaptureFieldMapOrUndefined;
    const c_linkedFieldsWithValuesArrayOfObjs = this.c_linkedFieldsWithValuesArrayOfObjs;
    const k_cardIDUserCreateNewCapture = DatabaseMobx.k_cardIDUserCreateNewCapture;
    const c_bitUsing3rdPartyIntegrationTF = DatabaseMobx.c_bitUsing3rdPartyIntegrationTF;
    const c_companyIntegrationOnTF = DatabaseMobx.c_companyIntegrationOnTF;
    const c_companyIntegrationLogRecordSuccessesTF = DatabaseMobx.c_companyIntegrationLogRecordSuccessesTF;
    const c_companyIntegrationIntegrationUniqueIDCEFieldID = DatabaseMobx.c_companyIntegrationIntegrationUniqueIDCEFieldID;
    const c_fieldMapOfDivisionOwners = DatabaseMobx.c_fieldMapOfDivisionOwners;
    const c_userSyncUserCEActionsInIntegrationSystemTF = UserMobx.c_userSyncUserCEActionsInIntegrationSystemTF;

    //3rd Party Integration is turned on in BIT and the Admin and in the User Panel Integration Settings
    if(!(c_bitUsing3rdPartyIntegrationTF && c_companyIntegrationOnTF && c_userSyncUserCEActionsInIntegrationSystemTF)) {
      return;
    }

    //no need to calculate anything or attempt to make an insert if there are 0 linked pairs created on the 3rd Party Integrations 'Mapping' subtab, the new capture will find 0 matches and not make an insert anyway
    if(c_linkedFieldsWithValuesArrayOfObjs.length === 0) {
      return;
    }

    //if this CE field is not filled out on the Setup tab (required to be filled out to insert/update integration system)
    if(c_setupSelectedIntegrationUniqueIDCEExpandedCaptureFieldMapOrUndefined === undefined) {
      return;
    }

    const integrationSystem = "vantagepoint";
    
    const divisionOwnersFieldID = c_fieldMapOfDivisionOwners.get("id");

    //find the raw value for division owners in the fieldID/value input arrays (use a division owners blank value if it can't be found)
    var newCECaptureDivisionIDsColonPercentsCommaOrUndefined = JSFUNC.get_first_array2_value_or_undefined_where_array1_matches_input(divisionOwnersFieldID, i_newCaptureAllCECaptureFieldIDsArray, i_newCaptureAllCERawValuesArray);
    if(newCECaptureDivisionIDsColonPercentsCommaOrUndefined === undefined) {
      newCECaptureDivisionIDsColonPercentsCommaOrUndefined = c_fieldMapOfDivisionOwners.get("fieldBlankValue");
    }

    //determine the credentials to use based on the capture highest percent division owner (or user division)
    const integrationsCredentialsRowIDOrM1 = this.determine_integrations_credentials_row_id_or_m1_from_ce_capture_division_owners_ids_colon_percent_comma(newCECaptureDivisionIDsColonPercentsCommaOrUndefined);
    if(!JSFUNC.is_number_not_nan_gt_0(integrationsCredentialsRowIDOrM1)) { //if credentials could not be found matching capture division or user division, don't perform the insert and don't create an integrations log entry
      return;
    }

    //create the new integration unique ID string based on the new CE captureID
    const newIntegrationOppUniqueIDString = this.create_new_integration_unique_id_string_from_new_ce_capture_id(i_newCECaptureID, newCECaptureDivisionIDsColonPercentsCommaOrUndefined);
    
    //make a copy of the raw CE values array to replace the blank integration unique ID with this computed one below
    var newCaptureAllCERawValuesWithNewIntegrationOppUniqueIDStringArray = JSFUNC.copy_array(i_newCaptureAllCERawValuesArray);

    //find the CE field (matched from CE captureFieldID) representing the integration unique ID field (filled out on the 3rd Party Integration 'Setup' subtab)
    for(let f = 0; f < i_newCaptureAllCECaptureFieldIDsArray.length; f++) {
      if(i_newCaptureAllCECaptureFieldIDsArray[f] === c_companyIntegrationIntegrationUniqueIDCEFieldID) {
        newCaptureAllCERawValuesWithNewIntegrationOppUniqueIDStringArray[f] = newIntegrationOppUniqueIDString;
      }
    }

    //gather any integration field default values turned on for any integration fields on the 3rd Party Integrations Mapping tab to pass to the js-php insert in addition to the list of mapped CE fields
    var integrationFieldDbNamesWithDefaultValuesArrayOfObjs = [];
    for(let linkedFieldWithValuesObj of c_linkedFieldsWithValuesArrayOfObjs) {
      if(linkedFieldWithValuesObj.integrationFieldUsingDefaultValueTF) {
        integrationFieldDbNamesWithDefaultValuesArrayOfObjs.push({
          integrationFieldDbName: linkedFieldWithValuesObj.integration_field_db_name,
          defaultValueString: linkedFieldWithValuesObj.integration_field_default_value_string
        })
      }
    }
  
    //create the new opp in the integration system, defining the translated fields/values (from CE to Integration) and calling a php POST to make the insert (send this command off without waiting to see if it was successful)
    const jsDescription = JSFUNC.js_description_from_action("AdminIntegrationsMobx", "integration_insert_integration_new_opp_with_newly_created_unique_id_string_from_new_ce_capture_id", ["i_newCECaptureID", "i_newCaptureAllCECaptureFieldIDsArray", "i_newCaptureAllCERawValuesArray"], [i_newCECaptureID, i_newCaptureAllCECaptureFieldIDsArray, i_newCaptureAllCERawValuesArray]);
  
    //changelog values
    const iudActionString = "iCEiIN";
    const changelogCaptureFieldID = -1;
    const changelogIntegrationFieldDbName = "{Insert New Opportunity}";
    var changelogNewCEFieldAndValueStringsArray = [];
    var changelogIntegrationNewFieldAndValueStringsArray = [];
  
    //intialize array to collect integration new field/value pairs converted from CE for this insert
    var integrationFieldsValuesArrayOfObjs = [];
    var debugStringsArray = [];
  
    //loop to assign the following new CE capture values (mapped equivalent value if necessary) to their integration fieldDbNames:
    //  "key"/"WBSNumber"/"WBS1" (with newIntegrationOppUniqueIDString)
    //  "Name"/"LongName"/"Level1Name" (with CE opportunity_name)
    //  "Stage" (with CE stage_id mapped integration value)
    //  "Org" (with CE division_owners_ids_colon_percent_comma mapped integration value)
    //plus all other CE fields found in i_newCaptureAllCECaptureFieldIDsArray (either the few standard fields from Create New Capture, or many more fields defined from a Capture Import)
    for(let f = 0; f < i_newCaptureAllCECaptureFieldIDsArray.length; f++) { //loop through every field/value pair within i_newCaptureAllCECaptureFieldIDsArray/newCaptureAllCERawValuesWithNewIntegrationOppUniqueIDStringArray (all fields filled out in create new capture process)
      var ceFieldID = i_newCaptureAllCECaptureFieldIDsArray[f];
      var ceNewValueRaw = newCaptureAllCERawValuesWithNewIntegrationOppUniqueIDStringArray[f];
  
      //match the CE field to 0, 1, or multiple linked integration fields, then use the new CE value, or translate through a matching mapped value
      var singleCEFieldIDMatchingIntegrationFieldsValuesAndDebugObj = this.integration_find_all_integration_field_db_names_and_mapped_values_matching_ce_field_id_and_ce_value_raw(iudActionString, i_newCECaptureID, ceFieldID, ceNewValueRaw, newIntegrationOppUniqueIDString)
      var singleCEFieldIDMatchingIntegrationFieldsValuesArrayOfObjs = singleCEFieldIDMatchingIntegrationFieldsValuesAndDebugObj.singleCEFieldIDMatchingIntegrationFieldsValuesArrayOfObjs;
      var ceFieldDebugString = singleCEFieldIDMatchingIntegrationFieldsValuesAndDebugObj.ceFieldDebugString;
  
      //loop over all linked pair(s) for this CE fieldID (should be 0 or 1 matches, but can be multiple integration fields linked to the same CE field)
      for(let matchingIntegrationFieldValueObj of singleCEFieldIDMatchingIntegrationFieldsValuesArrayOfObjs) {
        //add matching linked pair(s) from single CE fieldID to collection of all CE fields
        integrationFieldsValuesArrayOfObjs.push(matchingIntegrationFieldValueObj);
  
        //record changelog pieces for CE and integration for this one field that will be inserted into the integration new opp
        changelogNewCEFieldAndValueStringsArray.push(matchingIntegrationFieldValueObj.ceFieldDisplayName + ": '" + matchingIntegrationFieldValueObj.ceNewValueChangelogString + "'");
        changelogIntegrationNewFieldAndValueStringsArray.push(matchingIntegrationFieldValueObj.integrationFieldDbName + ": '" + matchingIntegrationFieldValueObj.integrationValueString + "'");
      }
  
      //add debug string from single CE fieldID to array (include f index number)
      debugStringsArray.push(f + " - " + ceFieldDebugString);
    }
  
    //if integration fields that have default values were provided as an arrayOfObjs input, add those here (that are not defined with real values in the mappings above) to the full list on integration insert field dbNames/values
    if(JSFUNC.is_array(integrationFieldDbNamesWithDefaultValuesArrayOfObjs)) {
      for(let integrationFieldDbNameWithDefaultValueObj of integrationFieldDbNamesWithDefaultValuesArrayOfObjs) { //loop through each integration field with a default value defined
        var matchingIntegrationFieldsValuesObjOrUndefined = JSFUNC.get_first_obj_from_arrayOfObjs_matching_field_value(integrationFieldsValuesArrayOfObjs, "integrationFieldDbName", integrationFieldDbNameWithDefaultValueObj.integrationFieldDbName);
        if(matchingIntegrationFieldsValuesObjOrUndefined === undefined) { //if the field with a set default value does not already exist in the full list of mapped fields with set values, append this field with its default value
          integrationFieldsValuesArrayOfObjs.push({
            integrationFieldDbName: integrationFieldDbNameWithDefaultValueObj.integrationFieldDbName,
            integrationValueString: integrationFieldDbNameWithDefaultValueObj.defaultValueString
          });
  
          //add debug string from single CE fieldID to array (include f index number)
          debugStringsArray.push("##default - " + ceFieldDebugString + "##");
        }
      }
    }
  
    //count the total fields to be inserted into the integration system
    const numIntegrationFieldValuePairs = integrationFieldsValuesArrayOfObjs.length;
  
    //create the changelog strings
    const changelogNewCEValueString = changelogNewCEFieldAndValueStringsArray.join("\n");
    const changelogIntegrationNewValueString = changelogIntegrationNewFieldAndValueStringsArray.join("\n");
  
    //build up to call the php that inserts an integration system opp with success/error functions for integration log entries
    const C_CallPhpScriptInsertIntegrationOpp = new JSPHP.ClassCallPhpScript("integrationInsertNewIntegrationOpp", jsDescription);
  
    C_CallPhpScriptInsertIntegrationOpp.add_post_var("i_integrationsCredentialsTblRowID", integrationsCredentialsRowIDOrM1);
    C_CallPhpScriptInsertIntegrationOpp.add_post_var("i_integrationSystem", integrationSystem);
    C_CallPhpScriptInsertIntegrationOpp.add_post_var("i_numIntegrationFieldValuePairs", numIntegrationFieldValuePairs);
    for(let i = 0; i < numIntegrationFieldValuePairs; i++) {
      var postVarFieldDbNameString = "i_integrationFieldDbName" + i;
      var postVarValueString = "i_integrationValueString" + i;
      var integrationFieldValueObj = integrationFieldsValuesArrayOfObjs[i];
      C_CallPhpScriptInsertIntegrationOpp.add_post_var(postVarFieldDbNameString, integrationFieldValueObj.integrationFieldDbName);
      C_CallPhpScriptInsertIntegrationOpp.add_post_var(postVarValueString, integrationFieldValueObj.integrationValueString);
    }
  
    C_CallPhpScriptInsertIntegrationOpp.add_return_vars("integrationErrorMessageOrBlankSuccess");
  
    const functionOnSuccessIntegrationInsert = (i_parseResponse) => {
      var integrationChangelogErrorMessage = ""; //blank changelog error message value for success
      if(i_parseResponse.integrationErrorMessageOrBlankSuccess !== "") {
        integrationChangelogErrorMessage = i_parseResponse.integrationErrorMessageOrBlankSuccess;
      }
  
      if(c_companyIntegrationLogRecordSuccessesTF || (integrationChangelogErrorMessage !== "")) {
        this.integration_insert_integration_changelog_entry(jsDescription, iudActionString, i_newCECaptureID, newIntegrationOppUniqueIDString, changelogCaptureFieldID, changelogIntegrationFieldDbName, changelogNewCEValueString, changelogIntegrationNewValueString, integrationChangelogErrorMessage);
      }
    }
    C_CallPhpScriptInsertIntegrationOpp.add_function("onSuccess", functionOnSuccessIntegrationInsert);
  
    const functionOnErrorIntegrationInsert = () => {
      this.integration_insert_integration_changelog_entry(jsDescription, iudActionString, i_newCECaptureID, newIntegrationOppUniqueIDString, changelogCaptureFieldID, changelogIntegrationFieldDbName, changelogNewCEValueString, changelogIntegrationNewValueString, "Unexpected issue handling the request");
    }
    C_CallPhpScriptInsertIntegrationOpp.add_function("onError", functionOnErrorIntegrationInsert);
  
    C_CallPhpScriptInsertIntegrationOpp.execute();

    //record_z_error(jsDescription, debugStringsArray.join("\n"));

    //update the new capture record with the new integration unique ID value (overwrite the original blank value from the new capture creation), also a changelog entry for it (no changelog entry created originally as the value was blank)
    const sendNotificationTF = false; //only capture/contract manager field updates send notifications, set it false anyway
    const updateIntegrationSystemLinkedFieldTF = false; //do not update the integration system with the integration unique ID since it was already included when the new opp was created in the integration system integration_insert_integration_new_opp_with_newly_created_unique_id_string_from_new_ce_capture_id(), without it the new opp could not be created, and don't want to update with the same value twice
    OpenCaptureMobx.a_details_update_field_value(c_setupSelectedIntegrationUniqueIDCEExpandedCaptureFieldMapOrUndefined, newIntegrationOppUniqueIDString, i_newCECaptureID, k_cardIDUserCreateNewCapture, sendNotificationTF, updateIntegrationSystemLinkedFieldTF, undefined, undefined);
  }


  //---------------------------------------------------------
  //--------- [Update] 3rd Party Integration system ---------
  //---------------------------------------------------------
  integration_update_multiple_integration_opp_fields_if_ce_fields_are_paired(i_ceCaptureID, i_ceFieldIDOrFieldIDsArray, i_ceNewRawValueOrValuesArray) {
    //alert("integration update [" + i_ceCaptureID + "]:\nfield: " + JSFUNC.print(i_ceFieldID) + "\nvalue: " + JSFUNC.print(i_ceNewValueRaw));
    
    const c_integrationSystemDisplayName = this.c_integrationSystemDisplayName;
    const c_setupSelectedIntegrationUniqueIDCEExpandedCaptureFieldMapOrUndefined = this.c_setupSelectedIntegrationUniqueIDCEExpandedCaptureFieldMapOrUndefined;
    const c_linkedFieldsWithValuesArrayOfObjs = this.c_linkedFieldsWithValuesArrayOfObjs;
    const c_productStylingObj = CaptureExecMobx.c_productStylingObj;
    const o_tbl_captures = DatabaseMobx.o_tbl_captures;
    const c_bitUsing3rdPartyIntegrationTF = DatabaseMobx.c_bitUsing3rdPartyIntegrationTF;
    const c_companyIntegrationOnTF = DatabaseMobx.c_companyIntegrationOnTF;
    const c_companyIntegrationLogRecordSuccessesTF = DatabaseMobx.c_companyIntegrationLogRecordSuccessesTF;
    const c_fieldMapOfCaptureID = DatabaseMobx.c_fieldMapOfCaptureID;
    const c_fieldMapOfDivisionOwners = DatabaseMobx.c_fieldMapOfDivisionOwners;
    const c_userSyncUserCEActionsInIntegrationSystemTF = UserMobx.c_userSyncUserCEActionsInIntegrationSystemTF;

    //3rd Party Integration is turned on in BIT and the Admin
    if(!(c_bitUsing3rdPartyIntegrationTF && c_companyIntegrationOnTF && c_userSyncUserCEActionsInIntegrationSystemTF)) {
      return;
    }
  
    //no need to calculate anything or attempt to make an insert if there are 0 linked pairs created on the 3rd Party Integrations 'Mapping' subtab, the new capture will find 0 matches and not make an insert anyway
    if(c_linkedFieldsWithValuesArrayOfObjs.length === 0) {
      return;
    }
  
    const jsDescription = JSFUNC.js_description_from_action("AdminIntegrationsMobx", "integration_update_multiple_integration_opp_fields_if_ce_fields_are_paired", ["i_ceCaptureID", "i_ceFieldIDOrFieldIDsArray", "i_ceNewRawValueOrValuesArray"], [i_ceCaptureID, i_ceFieldIDOrFieldIDsArray, i_ceNewRawValueOrValuesArray]);
    
    //convert inputs into arrays
    const ceFieldIDsArray = JSFUNC.convert_single_or_array_to_array(i_ceFieldIDOrFieldIDsArray);
    const ceNewRawValuesArray = JSFUNC.convert_single_or_array_to_array(i_ceNewRawValueOrValuesArray);
    const numCeFields = ceFieldIDsArray.length;

    //initialize that this integration unique ID string is unknown until the verification below can load the value from the capture
    const iudActionString = "uCEuIN";
    var integrationOppUniqueIDString = "--";

    //initialize an error message and other computed vars for capture/integration verification
    var integrationChangelogErrorMessage = undefined;
    var captureMapOrUndefined = undefined;
    var integrationsCredentialsRowIDOrM1 = -1;
  
    //check that the i_ceCaptureID provided is a valid CE capture (need this to extract the existing integration unique ID from the CE capture)
    captureMapOrUndefined = o_tbl_captures.get(i_ceCaptureID);
    if(captureMapOrUndefined === undefined) {
      integrationChangelogErrorMessage = c_productStylingObj.productName + " " + c_fieldMapOfCaptureID.get("display_name") + " '" + i_ceCaptureID + "' is not a valid capture";
    }
    else {
      //determine the credentials to use based on the capture highest percent division owner (or user division)
      const ceCaptureDivisionOwnersIDsColonPercentCommaOrUndefined = DatabaseMobx.capture_value_raw_or_undefined_from_capture_map_and_expanded_capture_field_map(captureMapOrUndefined, c_fieldMapOfDivisionOwners);
      integrationsCredentialsRowIDOrM1 = this.determine_integrations_credentials_row_id_or_m1_from_ce_capture_division_owners_ids_colon_percent_comma(ceCaptureDivisionOwnersIDsColonPercentCommaOrUndefined);
      if(!JSFUNC.is_number_not_nan_gt_0(integrationsCredentialsRowIDOrM1)) { //if credentials could not be found matching capture division or user division, then this division is exempt from doing any integration updates, don't perform the update and don't create an integrations log entry
        return;
      }

      //verify if all Setup subtab fields are filled out (if an APi Connection or Unique ID field is not filled out, write an integration log message)
      integrationChangelogErrorMessage = this.integration_verify_all_setup_and_mapping_is_filled_out_undefined_or_error_message_string();
      if(integrationChangelogErrorMessage === undefined) {
        //load the integration unique ID from this CE capture using the input i_ceCaptureID loaded captureMap
        const ceIntegrationUniqueIDValueMaskSortIfoObj = DatabaseMobx.value_mask_sort_ifo_canedit_obj_from_capture_map_and_expanded_capture_field_map(captureMapOrUndefined, c_setupSelectedIntegrationUniqueIDCEExpandedCaptureFieldMapOrUndefined, true); //plainTextTF is true since valueMask is not needed
        if(!ceIntegrationUniqueIDValueMaskSortIfoObj.isFilledOutTF) { //if this CE capture does not have the integration unique ID field filled out
          integrationChangelogErrorMessage = c_productStylingObj.productName +  " Capture Field '" + c_setupSelectedIntegrationUniqueIDCEExpandedCaptureFieldMapOrUndefined.get("display_name") + "' is not filled out with the " + c_integrationSystemDisplayName + " unique ID that links this opportunity across the 2 systems";
        }
        else { //get the CE integration opp uniqueID string stored in the CE capture linking the CE capture to the integration system opp
          integrationOppUniqueIDString = ceIntegrationUniqueIDValueMaskSortIfoObj.valueMaskPlainText;
        }
      }
    }

    //write integration changelog entries for each CE field attempted and do not perform integration updates if there was an error message above
    if(integrationChangelogErrorMessage !== undefined) {
      for(let f = 0; f < numCeFields; f++) {
        this.integration_insert_integration_changelog_entry(jsDescription, iudActionString, i_ceCaptureID, "--", ceFieldIDsArray[f], "--", "--", "--", integrationChangelogErrorMessage);
      }
      return;
    }

    //loop through each of the requested CE fields/values to build a list of all integration fields to update
    var integrationUpdatesArrayOfObjs = [];
    var u = 0; //integration individual update counter (each CE field can be mapped to mulitple integration fields)
    for(let f = 0; f < numCeFields; f++) {
      var ceFieldID = ceFieldIDsArray[f];
      var ceNewRawValue = ceNewRawValuesArray[f];

      //match the CE field to 0, 1, or multiple linked integration fields, then use the new CE value, or translate through a matching mapped value
      var singleCEFieldIDMatchingIntegrationFieldsValuesAndDebugObj = this.integration_find_all_integration_field_db_names_and_mapped_values_matching_ce_field_id_and_ce_value_raw(iudActionString, i_ceCaptureID, ceFieldID, ceNewRawValue, integrationOppUniqueIDString);
      var singleCEFieldIDMatchingIntegrationFieldsValuesArrayOfObjs = singleCEFieldIDMatchingIntegrationFieldsValuesAndDebugObj.singleCEFieldIDMatchingIntegrationFieldsValuesArrayOfObjs;
      for(let i = 0; i < singleCEFieldIDMatchingIntegrationFieldsValuesArrayOfObjs.length; i++) {
        integrationUpdatesArrayOfObjs.push({
          ceFieldID: ceFieldID,
          ceNewValueChangelogString: singleCEFieldIDMatchingIntegrationFieldsValuesArrayOfObjs[i].ceNewValueChangelogString,
          postVarFieldDbNameString: "i_if" + u,
          postVarValueString: "i_iv" + u,
          integrationFieldDbName: singleCEFieldIDMatchingIntegrationFieldsValuesArrayOfObjs[i].integrationFieldDbName,
          integrationValueString: singleCEFieldIDMatchingIntegrationFieldsValuesArrayOfObjs[i].integrationValueString
        });

        //increment the integrations update counter
        u++;
      }
    }
    
    //if 0 linked pairs matched any of the input i_ceFieldIDOrFieldIDsArray, do not make an update to the integration system (no linked integration field to these CE fields to update)
    const numIntegrationUpdates = integrationUpdatesArrayOfObjs.length;
    if(numIntegrationUpdates === 0) {
      return;
    }
    
    //call a php function to update the same field to the equivalent value in the integration system to sync with the CE update
    const C_CallPhpScript = new JSPHP.ClassCallPhpScript("integrationUpdateIntegrationOppMultipleFieldsWithValues", jsDescription);
  
    C_CallPhpScript.add_post_var("i_integrationSystem", "vantagepoint");
    C_CallPhpScript.add_post_var("i_integrationsCredentialsTblRowID", integrationsCredentialsRowIDOrM1);
    C_CallPhpScript.add_post_var("i_integrationOppUniqueIDString", integrationOppUniqueIDString);
    C_CallPhpScript.add_post_var("i_numIntegrationUpdates", numIntegrationUpdates);
    for(let integrationUpdateObj of integrationUpdatesArrayOfObjs) {
      C_CallPhpScript.add_post_var(integrationUpdateObj.postVarFieldDbNameString, integrationUpdateObj.integrationFieldDbName);
      C_CallPhpScript.add_post_var(integrationUpdateObj.postVarValueString, integrationUpdateObj.integrationValueString);
    }
  
    C_CallPhpScript.add_return_vars("integrationErrorMessagesOrBlankSuccessesArray");
  
    //update integrations log on success or error
    const functionOnSuccess = (i_parseResponse) => {
      //make sure the output is an array of strings
      var numIntegrationErrorMessagesOrBlankSuccesses = 0;
      if(JSFUNC.is_array(i_parseResponse.integrationErrorMessagesOrBlankSuccessesArray)) {
        numIntegrationErrorMessagesOrBlankSuccesses = i_parseResponse.integrationErrorMessagesOrBlankSuccessesArray.length;
      }

      //loop through the original integration updates list, fetch the corresponding error message from the return array
      for(let u = 0; u < numIntegrationUpdates; u++) {
        var integrationErrorMessageOrBlankSuccess = "";
        if(u > (numIntegrationErrorMessagesOrBlankSuccesses - 1)) {
          integrationErrorMessageOrBlankSuccess = "'" + integrationUpdateObj.integrationFieldDbName + "' field not returned from the update operation";
        }
        else {
          integrationErrorMessageOrBlankSuccess = i_parseResponse.integrationErrorMessagesOrBlankSuccessesArray[u];
        }

        if(c_companyIntegrationLogRecordSuccessesTF || (integrationErrorMessageOrBlankSuccess !== "")) { //do not create a success integrations changelog entry if the 'record successes' switch is turned off
          var integrationUpdateObj = integrationUpdatesArrayOfObjs[u];
          this.integration_insert_integration_changelog_entry(jsDescription, iudActionString, i_ceCaptureID, integrationOppUniqueIDString, integrationUpdateObj.ceFieldID, integrationUpdateObj.integrationFieldDbName, integrationUpdateObj.ceNewValueChangelogString, integrationUpdateObj.integrationValueString, integrationErrorMessageOrBlankSuccess);
        }
      }
    }
    C_CallPhpScript.add_function("onSuccess", functionOnSuccess);
  
    const functionOnError = () => {
      for(let u = 0; u < numIntegrationUpdates; u++) {
        var integrationUpdateObj = integrationUpdatesArrayOfObjs[u];
        this.integration_insert_integration_changelog_entry(jsDescription, iudActionString, i_ceCaptureID, integrationOppUniqueIDString, integrationUpdateObj.ceFieldID, integrationUpdateObj.integrationFieldDbName, integrationUpdateObj.ceNewValueChangelogString, integrationUpdateObj.integrationValueString, "Unexpected CE issue handling the request");
      }
    }
    C_CallPhpScript.add_function("onError", functionOnError);
  
    C_CallPhpScript.execute();
  }


  //---------------------------------------------------------
  //--------- [Delete] 3rd Party Integration system ---------
  //---------------------------------------------------------
  integration_delete_integration_opp(i_deletedCaptureMapCopy) {
    //alert("integration delete");
    
    const c_integrationSystemDisplayName = this.c_integrationSystemDisplayName;
    const c_setupSelectedIntegrationUniqueIDCEExpandedCaptureFieldMapOrUndefined = this.c_setupSelectedIntegrationUniqueIDCEExpandedCaptureFieldMapOrUndefined;
    const c_productStylingObj = CaptureExecMobx.c_productStylingObj;
    const c_bitUsing3rdPartyIntegrationTF = DatabaseMobx.c_bitUsing3rdPartyIntegrationTF;
    const c_companyIntegrationOnTF = DatabaseMobx.c_companyIntegrationOnTF;
    const c_companyIntegrationLogRecordSuccessesTF = DatabaseMobx.c_companyIntegrationLogRecordSuccessesTF;
    const c_fieldMapOfCaptureID = DatabaseMobx.c_fieldMapOfCaptureID;
    const c_fieldMapOfDivisionOwners = DatabaseMobx.c_fieldMapOfDivisionOwners;
    const c_userSyncUserCEActionsInIntegrationSystemTF = UserMobx.c_userSyncUserCEActionsInIntegrationSystemTF;

    //3rd Party Integration is turned on in BIT and the Admin and in the User Panel Integration Settings
    if(!(c_bitUsing3rdPartyIntegrationTF && c_companyIntegrationOnTF && c_userSyncUserCEActionsInIntegrationSystemTF)) {
      return;
    }
  
    const integrationSystem = "vantagepoint";
  
    const jsDescription = JSFUNC.js_description_from_action("AdminIntegrationsMobx", "integration_delete_integration_opp", ["i_deletedCaptureMapCopy"], [i_deletedCaptureMapCopy]);
    
    //changelog values
    const iudActionString = "dCEdIN";
    var ceCaptureID = -1;
    var integrationOppUniqueIDString = "--";
    const changelogCaptureFieldID = -1;
    const changelogIntegrationFieldDbName = "{Delete Existing Opportunity}";
    const changelogNewCEValueString = "--";
    const changelogIntegrationNewValueString = "--";
  
    //check that the i_deletedCaptureMapCopy provided is a valid CE capture (need this to extract the existing integration unique ID from the CE capture)
    if(i_deletedCaptureMapCopy === undefined) {
      const captureIDNotAValidCaptureErrorMessage = "Input CE Capture Map is not a valid capture";
      this.integration_insert_integration_changelog_entry(jsDescription, iudActionString, ceCaptureID, integrationOppUniqueIDString, changelogCaptureFieldID, changelogIntegrationFieldDbName, changelogNewCEValueString, changelogIntegrationNewValueString, captureIDNotAValidCaptureErrorMessage);
      return;
    }

    ceCaptureID = i_deletedCaptureMapCopy.get(c_fieldMapOfCaptureID.get("db_name"));

    //determine the credentials to use based on the capture highest percent division owner (or user division)
    const ceCaptureDivisionOwnersIDsColonPercentCommaOrUndefined = DatabaseMobx.capture_value_raw_or_undefined_from_capture_map_and_expanded_capture_field_map(i_deletedCaptureMapCopy, c_fieldMapOfDivisionOwners);
    const integrationsCredentialsRowIDOrM1 = this.determine_integrations_credentials_row_id_or_m1_from_ce_capture_division_owners_ids_colon_percent_comma(ceCaptureDivisionOwnersIDsColonPercentCommaOrUndefined);
    if(!JSFUNC.is_number_not_nan_gt_0(integrationsCredentialsRowIDOrM1)) { //if credentials could not be found matching capture division or user division, don't perform the insert and don't create an integrations log entry
      return;
    }
  
    //verify if all Setup subtab fields are filled out
    const setupErrorMessageOrUndefined = this.integration_verify_all_setup_and_mapping_is_filled_out_undefined_or_error_message_string();
    if(setupErrorMessageOrUndefined !== undefined) { //an APi Connection or Unique ID field is not filled out, write an integration log message
      this.integration_insert_integration_changelog_entry(jsDescription, iudActionString, ceCaptureID, integrationOppUniqueIDString, changelogCaptureFieldID, changelogIntegrationFieldDbName, changelogNewCEValueString, changelogIntegrationNewValueString, setupErrorMessageOrUndefined);
      return;
    }
  
    //load the integration unique ID from this CE capture using the input ceCaptureID loaded captureMap
    const ceIntegrationUniqueIDValueMaskSortIfoObj = DatabaseMobx.value_mask_sort_ifo_canedit_obj_from_capture_map_and_expanded_capture_field_map(i_deletedCaptureMapCopy, c_setupSelectedIntegrationUniqueIDCEExpandedCaptureFieldMapOrUndefined, true); //plainTextTF is true
    if(!ceIntegrationUniqueIDValueMaskSortIfoObj.isFilledOutTF) { //if this CE capture does not have the integration unique ID field filled out
      const ceIntegrationUniqueIDFieldIsNotFilledOutErrorMessage = c_productStylingObj.productName +  " Capture Field '" + c_setupSelectedIntegrationUniqueIDCEExpandedCaptureFieldMapOrUndefined.get("display_name") + "' is not filled out with the " + c_integrationSystemDisplayName + " unique ID that links this opportunity across the 2 systems";
      this.integration_insert_integration_changelog_entry(jsDescription, iudActionString, ceCaptureID, integrationOppUniqueIDString, changelogCaptureFieldID, changelogIntegrationFieldDbName, changelogNewCEValueString, changelogIntegrationNewValueString, ceIntegrationUniqueIDFieldIsNotFilledOutErrorMessage);
      return;
    }
  
    //get the CE integration opp uniqueID string stored in the CE capture linking the CE capture to the integration system opp
    integrationOppUniqueIDString = ceIntegrationUniqueIDValueMaskSortIfoObj.valueMaskPlainText;
  
    const C_CallPhpScriptDeleteIntegrationOpp = new JSPHP.ClassCallPhpScript("integrationDeleteIntegrationOpp", jsDescription);
  
    C_CallPhpScriptDeleteIntegrationOpp.add_post_var("i_integrationsCredentialsTblRowID", integrationsCredentialsRowIDOrM1);
    C_CallPhpScriptDeleteIntegrationOpp.add_post_var("i_integrationSystem", integrationSystem);
    C_CallPhpScriptDeleteIntegrationOpp.add_post_var("i_integrationOppUniqueIDString", integrationOppUniqueIDString);
  
    C_CallPhpScriptDeleteIntegrationOpp.add_return_vars("integrationErrorMessageOrBlankSuccess");
  
    const functionOnSuccessIntegrationDelete = (i_parseResponse) => {
      var integrationChangelogErrorMessage = ""; //blank changelog error message value for success
      if(i_parseResponse.integrationErrorMessageOrBlankSuccess !== "") {
        integrationChangelogErrorMessage = i_parseResponse.integrationErrorMessageOrBlankSuccess;
      }
      
      if(c_companyIntegrationLogRecordSuccessesTF || (integrationChangelogErrorMessage !== "")) {
        this.integration_insert_integration_changelog_entry(jsDescription, iudActionString, ceCaptureID, integrationOppUniqueIDString, changelogCaptureFieldID, changelogIntegrationFieldDbName, changelogNewCEValueString, changelogIntegrationNewValueString, integrationChangelogErrorMessage);
      }
    }
    C_CallPhpScriptDeleteIntegrationOpp.add_function("onSuccess", functionOnSuccessIntegrationDelete);
  
    const functionOnErrorIntegrationDelete = () => {
      this.integration_insert_integration_changelog_entry(jsDescription, iudActionString, ceCaptureID, integrationOppUniqueIDString, changelogCaptureFieldID, changelogIntegrationFieldDbName, changelogNewCEValueString, changelogIntegrationNewValueString, "Unexpected issue handling the request");
    }
    C_CallPhpScriptDeleteIntegrationOpp.add_function("onError", functionOnErrorIntegrationDelete);
  
    C_CallPhpScriptDeleteIntegrationOpp.execute();
  }

  
  //---------------------------------------------------------
  //- [CE changelog and other functions] Integration system -
  //---------------------------------------------------------
  integration_insert_integration_changelog_entry(i_jsDescription, i_iudActionString, i_ceCaptureID, i_integrationOppUniqueIDString, i_changelogCaptureFieldID, i_changelogIntegrationFieldDbName, i_changelogNewCEValueString, i_changelogIntegrationNewValueString, i_integrationsChangelogErrorMessageOrUndefined) {
    const o_userID = UserMobx.o_userID;
  
    const nowDateTimeUtc = JSFUNC.now_naturalDateTimeUtcYmdHis();
  
    const changelogFieldNamesArray = ["datetime_utc", "user_id", "iud_action_string", "ce_capture_id", "integration_unique_id_string", "ce_field_id", "integration_field_db_name", "new_ce_value_string", "new_integration_value_string", "error_message"];
    const changelogValuesArray = [nowDateTimeUtc, o_userID, i_iudActionString, i_ceCaptureID, i_integrationOppUniqueIDString, i_changelogCaptureFieldID, i_changelogIntegrationFieldDbName, i_changelogNewCEValueString, i_changelogIntegrationNewValueString, i_integrationsChangelogErrorMessageOrUndefined];
    const changelogIdsbArray = ["s", "i", "s", "i", "s", "i", "s", "s", "s", "s"];
  
    const C_CallPhpTblUID = new JSPHP.ClassCallPhpTblUID(i_jsDescription);
    C_CallPhpTblUID.add_insert("tbl_a_integrations_log", changelogFieldNamesArray, changelogValuesArray, changelogIdsbArray);
    C_CallPhpTblUID.execute();
  }


  integration_verify_all_setup_and_mapping_is_filled_out_undefined_or_error_message_string() {
    const c_setupAllIntegrationApiConnectionFieldsArrayOfObjs = this.c_setupAllIntegrationApiConnectionFieldsArrayOfObjs;
    const c_setupSelectedIntegrationUniqueIDCEExpandedCaptureFieldMapOrUndefined = this.c_setupSelectedIntegrationUniqueIDCEExpandedCaptureFieldMapOrUndefined;
    const c_productStylingObj = CaptureExecMobx.c_productStylingObj;
  
    //check that every 'API Connection' field on the integration Setup tab is filled out
    const notFilledOutApiConnectionFieldDisplayNamesArray = JSFUNC.filtered_array_of_values_from_arrayOfObjs_and_output_field_name_matching_filter_field_values(c_setupAllIntegrationApiConnectionFieldsArrayOfObjs, "fieldDisplayName", "isFilledOutTF", false);
    if(notFilledOutApiConnectionFieldDisplayNamesArray.length > 0) {
      return("'API Connection' field(s) on the Setup tab are not filled out: " + JSFUNC.convert_array_to_display_comma_list(notFilledOutApiConnectionFieldDisplayNamesArray));
    }
  
    //check that 
    if(c_setupSelectedIntegrationUniqueIDCEExpandedCaptureFieldMapOrUndefined === undefined) {
      return("'Unique ID Field Created in " + c_productStylingObj.productName + "' field on the Setup tab is not filled out");
    }
  
    return(undefined);
  }
  
  
  integration_find_all_integration_field_db_names_and_mapped_values_matching_ce_field_id_and_ce_value_raw(i_iudActionString, i_ceCaptureID, i_ceFieldID, i_ceValueRaw, i_newIntegrationOppUniqueIDString) {
    const c_linkedFieldsWithValuesArrayOfObjs = this.c_linkedFieldsWithValuesArrayOfObjs;
    const c_tbl_captures_fields = DatabaseMobx.c_tbl_captures_fields;
  
    //initialize output obj vars
    var singleCEFieldIDMatchingIntegrationFieldsValuesArrayOfObjs = [];
    var ceFieldDebugString = "";
  
    const jsDescription = JSFUNC.js_description_from_action("AdminIntegrationsMobx", "integration_find_all_integration_field_db_names_and_mapped_values_matching_ce_field_id_and_ce_value_raw", ["i_iudActionString", "i_ceCaptureID", "i_ceFieldID", "i_ceValueRaw", "i_newIntegrationOppUniqueIDString"], [i_iudActionString, i_ceCaptureID, i_ceFieldID, i_ceValueRaw, i_newIntegrationOppUniqueIDString]);
  
    ceFieldDebugString += "[ceCID" + i_ceCaptureID + ", ceFID" + i_ceFieldID + "] [[" + i_ceValueRaw + "]]";
  
    //find the integration linked fields pair(s) containing this i_ceFieldID
    var ceFieldMatchingLinkedFieldsWithValuesArrayOfObjs = JSFUNC.filtered_arrayOfObjs_from_arrayOfObjs_matching_single_field_value(c_linkedFieldsWithValuesArrayOfObjs, "capture_field_id", i_ceFieldID);
    if(ceFieldMatchingLinkedFieldsWithValuesArrayOfObjs.length === 0) {
      ceFieldDebugString += " (no 'linked fields' created that includes capture fieldID " + i_ceFieldID + ")";
    }
    else {
      //verify CE field and get its properties, mask the new raw CE value for changelogs
      var insertCECaptureFieldExpandedCaptureFieldMapOrUndefined = c_tbl_captures_fields.get(i_ceFieldID);
      if(insertCECaptureFieldExpandedCaptureFieldMapOrUndefined === undefined) { //CE capture field does not exist, changelog error and leave this field off of the integration insert list
        var ceFieldMatchingIntegrationFieldDbNamesArray = JSFUNC.get_column_vector_from_arrayOfObjs(ceFieldMatchingLinkedFieldsWithValuesArrayOfObjs, "integration_field_db_name");
        var ceFieldMatchingIntegrationFieldDbNamesCommaDisplayList = JSFUNC.convert_array_to_display_comma_list(ceFieldMatchingIntegrationFieldDbNamesArray);
        var noCEFieldMatchingCEFieldIDErrorMessage = "CE Capture Field ID '" + i_ceFieldID + "' does not exist in CE";
        this.integration_insert_integration_changelog_entry(jsDescription, i_iudActionString, i_ceCaptureID, i_newIntegrationOppUniqueIDString, i_ceFieldID, ceFieldMatchingIntegrationFieldDbNamesCommaDisplayList, i_ceValueRaw, "", noCEFieldMatchingCEFieldIDErrorMessage);
        ceFieldDebugString += " !!!!! No CE Field matching i_ceFieldID !!!!!";
      }
      else { //CE field is valid
        //get masked and ifo values for CE capture raw value
        var ceFieldDisplayName = insertCECaptureFieldExpandedCaptureFieldMapOrUndefined.get("display_name");
        var ceFieldFieldTypeObj = insertCECaptureFieldExpandedCaptureFieldMapOrUndefined.get("fieldTypeObj");
        var ceValueMaskSortIfoObj = DatabaseMobx.value_mask_sort_ifo_obj_from_value_raw_and_field_type_obj(i_ceValueRaw, ceFieldFieldTypeObj);
  
        //create the "i_ceValueRaw {ceValueMaskPlainText}" changelog entry string from the CE raw value
        var ceValueRawString = JSFUNC.num2str(i_ceValueRaw);
        var ceValueTrueRawIntegrationsString = JSFUNC.num2str(ceValueMaskSortIfoObj.valueTrueRawIntegrations);
        var ceNewValueMaskPlainTextString = JSFUNC.num2str(ceValueMaskSortIfoObj.valueMaskPlainText);
        var ceNewValueChangelogString = ceValueRawString;
        if(ceValueRawString !== ceNewValueMaskPlainTextString) { //if the mask value of this updated field value is different from the raw value, display both for the CE changelog column
          ceNewValueChangelogString = ceValueRawString + " {" + ceNewValueMaskPlainTextString + "}";
        }
        ceFieldDebugString += " [ceFieldDisplayName: '" + ceFieldDisplayName + "'] [[" + ceNewValueChangelogString + "]]";
  
        //loop over each integration field linked to this CE field (can have multiple different integration fields mapped to the same CE field)
        for(let linkedFieldsWithValuesObj of ceFieldMatchingLinkedFieldsWithValuesArrayOfObjs) {
          //unpack the integration fieldDbName and the mapped values between CE and the integration system
          var integrationFieldDbName = linkedFieldsWithValuesObj.integration_field_db_name; //"key","WBSNumber","WBS1","Name","LongName","Level1Name","Stage","Org",etc (also special "{ignore}" to skip mapped value from going into update)
          var canMapValuesTF = linkedFieldsWithValuesObj.canMapValuesTF;
          var mappedValuesArrayOfObjs = linkedFieldsWithValuesObj.mappedValuesArrayOfObjs;
          var hasAtLeast1MappedValueTF = linkedFieldsWithValuesObj.hasAtLeast1MappedValueTF;
          ceFieldDebugString += " {integrationFieldDbName: '" + integrationFieldDbName + "'}";
  
          //initialize the new integration value for this field as ""
          var matchingIntegrationValueString = "";
  
          //if there's mapped matching values between CE and the integration system, find the matching CE value raw and get its mapped integration value
          var matchingCEMappedValueIntegrationIgnoreTF = false;
          var noMatchingCEMappedValueTF = false;
          if(!(canMapValuesTF && hasAtLeast1MappedValueTF)) { //if this CE field can't map values (text/textarea/number/date/etc type fields), or can and has 0 mapped values, use the true raw value for integrations (converted num2str() above) directly
            matchingIntegrationValueString = ceValueTrueRawIntegrationsString;
            ceFieldDebugString += " {{direct '" + matchingIntegrationValueString + "'}}";
          }
          else { //select/multiselect/sharedpercent field that needs value mapping, match the CE value with the mapped integration value string
            var matchingCEValueFoundTF = false; //loop through all mapped values to match input CE value (converted to string or known isFilledOutTF) to the mapped CE raw value string to get its mapped integration value
            for(let mappedValueObj of mappedValuesArrayOfObjs) {
              if((mappedValueObj.capture_field_value_string === ceValueRawString) || (!mappedValueObj.captureFieldValueMaskSortIfoObj.isFilledOutTF && !ceValueMaskSortIfoObj.isFilledOutTF)) { //either string values match exactly, or both are considered not filled out (might be -1 vs 0 or a select raw value which are both not filled out)
                matchingCEValueFoundTF = true; //found a mapped CE raw value string that matched the input CE value
  
                if(mappedValueObj.integration_value_string === "{ignore}") { //special CE code for integration value mapping to ignore a selected value from CE, don't include this CE field/value as part of the output arrayOfObjs of integration fields/values to update
                  matchingIntegrationValueString = "--"; //not used if ignored
                  matchingCEMappedValueIntegrationIgnoreTF = true;
                  ceFieldDebugString += " {{ignored}}";
                }
                else { //use mapped integration value string found matching input CE value
                  matchingIntegrationValueString = mappedValueObj.integration_value_string;
                  ceFieldDebugString += " {{matched '" + mappedValueObj.integration_value_string + "'}}";
                }
  
                break;
              }
            }
  
            if(!matchingCEValueFoundTF) { //no matching CE raw value string among mapped CE values
              if(!ceValueMaskSortIfoObj.isFilledOutTF) { //CE valueRaw is not filled out, use "" empty string for the integration value (this is done here because the Admin may have mapped a CE value of "" or 0 or -1 to an integration value that is not "", like "empty" or "1" or something they need specifically)
                matchingIntegrationValueString = "";
                ceFieldDebugString += ' {{ce not filled out, "" used}}';
              }
              else { //CE value was filled out, but no matching mapping was found, still continue but write a changelog entry and use "" emptry string for the integration value (changelog error message has "[skipped]" in front to give a different color to the message in the Log)
                matchingIntegrationValueString = "";
                noMatchingCEMappedValueTF = true; //integration field will not be included as matching the CE field (will be essentially skipped)
                var ceValueNotMappedToIntegrationValueErrorMessage = "[skipped] CE value '" + ceNewValueMaskPlainTextString + "' is not mapped to an Integration value, this field was not set or modified in the Integration database";
                this.integration_insert_integration_changelog_entry(jsDescription, i_iudActionString, i_ceCaptureID, i_newIntegrationOppUniqueIDString, i_ceFieldID, integrationFieldDbName, ceNewValueChangelogString, "{No Mapped Integration Value}", ceValueNotMappedToIntegrationValueErrorMessage);
                ceFieldDebugString += " @@@@@ CE value is not mapped to an integration value @@@@@";
              }
            }
          }
  
          //apply any special handling steps on each integration value string before sending to the integration database
          if(ceFieldFieldTypeObj.valueDisplayIsDateOrDateTimeTF && !ceValueMaskSortIfoObj.isFilledOutTF) { //any of the 5 date types and not filled out
            if(ceFieldFieldTypeObj.valueDisplayIsDateTF) {
              matchingIntegrationValueString = DatabaseMobx.c_companyIntegrationSpecialIntegrationBlankDate;
            }
            else if(ceFieldFieldTypeObj.valueDisplayIsDateTimeTF) {
              matchingIntegrationValueString = DatabaseMobx.c_companyIntegrationSpecialIntegrationBlankDateTime;
            }
            ceFieldDebugString += " {{specialhandling '" + matchingIntegrationValueString + "'}}";
          }
  
          //add integration fieldDbName and new value string to the collection array (if not ignored), also computed ce field/value display for changelog entries
          if(!matchingCEMappedValueIntegrationIgnoreTF && !noMatchingCEMappedValueTF) {
            singleCEFieldIDMatchingIntegrationFieldsValuesArrayOfObjs.push({
              ceFieldDisplayName: ceFieldDisplayName,
              ceNewValueChangelogString: ceNewValueChangelogString,
              integrationFieldDbName: integrationFieldDbName,
              integrationValueString: matchingIntegrationValueString
            });
          }
        }
      }
    }
  
    return({
      singleCEFieldIDMatchingIntegrationFieldsValuesArrayOfObjs: singleCEFieldIDMatchingIntegrationFieldsValuesArrayOfObjs,
      ceFieldDebugString: ceFieldDebugString
    });
  }
  
  
  create_new_integration_unique_id_string_from_new_ce_capture_id(i_newCECaptureID, i_newCECaptureDivisionIDsColonPercentsCommaOrUndefined=undefined) {
    const c_tbl_a_divisions = DatabaseMobx.c_tbl_a_divisions;

    //initialize the integration unique ID prefix string as empty
    var integrationUniqueIDPrefix = "";

    //sort the raw value of sharedpercent colon comma list divisionIDs and their percents, and get the one with the largest percent ownership to use as the integration unique ID prefix (if filled out in tbl_a_divisions for that divisionID)
    if(JSFUNC.is_string(i_newCECaptureDivisionIDsColonPercentsCommaOrUndefined)) {
      const newCECaptureHighestPercentDivisionIntsObjOrUndefined = JSFUNC.get_first_ints_obj_or_undefined_from_colon_comma_list_after_sorting(i_newCECaptureDivisionIDsColonPercentsCommaOrUndefined, 2, false);
      if(newCECaptureHighestPercentDivisionIntsObjOrUndefined !== undefined) {
        const newCECaptureHighestPercentDivisionID = newCECaptureHighestPercentDivisionIntsObjOrUndefined.int1;
        const newCECaptureHighestExpandedDivisionMapOrUndefined = c_tbl_a_divisions.get(newCECaptureHighestPercentDivisionID);
        if(newCECaptureHighestExpandedDivisionMapOrUndefined !== undefined) {
          if(newCECaptureHighestExpandedDivisionMapOrUndefined.get("calcIntegrationPrefixIsFilledOutTF")) {
            integrationUniqueIDPrefix = newCECaptureHighestExpandedDivisionMapOrUndefined.get("integration_new_capture_integration_unique_id_prefix");
          }
        }
      }
    }

    //build string "CE1234" or "PREFIX-CE1234"
    var newIntegrationUniqueIDString = "";
    if(integrationUniqueIDPrefix !== "") {
      newIntegrationUniqueIDString += integrationUniqueIDPrefix + "-";
    }
    newIntegrationUniqueIDString += "CE" + i_newCECaptureID;

    return(newIntegrationUniqueIDString);
  }


  determine_integrations_credentials_row_id_or_m1_from_ce_capture_division_owners_ids_colon_percent_comma(i_ceCaptureDivisionOwnersIDsColonPercentComma) {
    const o_tbl_a_integrations_credentials = DatabaseMobx.o_tbl_a_integrations_credentials;
    const c_userDivisionID = UserMobx.c_userDivisionID;

    //first, loop through to see if any of the credentials rows have "all" listed for the divisionIDs, if so, use the first one encountered, regardless of capture division owners or user division
    for(let integrationsCredentialsMap of o_tbl_a_integrations_credentials.values()) {
      if(integrationsCredentialsMap.get("division_ids_comma") === "all") {
        return(integrationsCredentialsMap.get("id")); //return the matching credentials rowID
      }
    }

    //initialize divisionID to use (from capture division owners (highest percent), or from the user's division if the capture has an empty division field)
    var ceCaptureDivisionIDOrUserDivisionIDOrM1 = -1;

    //first try to see if the capture division owners field is filled out and get the divisionID with the most percent ownership
    const ceCaptureHighestPercentDivisionIntsObjOrUndefined = JSFUNC.get_first_ints_obj_or_undefined_from_colon_comma_list_after_sorting(i_ceCaptureDivisionOwnersIDsColonPercentComma, 2, false);
    if(ceCaptureHighestPercentDivisionIntsObjOrUndefined !== undefined) {
      ceCaptureDivisionIDOrUserDivisionIDOrM1 = ceCaptureHighestPercentDivisionIntsObjOrUndefined.int1;
    }
    else { //if the divison field is blank, use the user's divisionID
      ceCaptureDivisionIDOrUserDivisionIDOrM1 = c_userDivisionID;
    }
    
    //if a valid divisionID was found for the capture/user, try to match it to the multiple integration credential entries, each with a comma list of divisionIDs that they apply to
    if(JSFUNC.is_number_not_nan_gt_0(ceCaptureDivisionIDOrUserDivisionIDOrM1)) {
      for(let integrationsCredentialsMap of o_tbl_a_integrations_credentials.values()) {
        var singleIntegrationsCredentialsDivisionIDsArray = JSFUNC.convert_comma_list_to_int_array(integrationsCredentialsMap.get("division_ids_comma")); //pick the first credentials that has this divisionID listed in the comma list or has "all" set
        if(JSFUNC.in_array(ceCaptureDivisionIDOrUserDivisionIDOrM1, singleIntegrationsCredentialsDivisionIDsArray)) {
          return(integrationsCredentialsMap.get("id")); //return the matching credentials rowID
        }
      }
    }

    //if the division was assigned to Unassigned (-1), or the user has no division assigned, or the credentials don't have this divisionID assigned to a credential, return a credentials rowID of -1 
    return(-1);
  }


}
export default new AdminIntegrationsMobx();
